import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Link, useHistory, withRouter } from "react-router-dom";
import slugme from "slugme";
import images from "../../../../ressources/images";
import "./SearchResult.scss";
import LazyLoad from "react-lazyload";
import { saveGoBackPage } from "../../../../utils/history";
import OneHrCourseItem from "components/OneHr/OneHrCourseItem";
import { connect } from "react-redux";

const SearchResult = ({ results, displayBrand, filters }) => {
  const [luxeBrands, setLuxeBrands] = useState([]);
  const [oneHRCategories, setOneHRCategories] = useState([]);
  const { t } = useTranslation();

  const removeDuplicates = (duplicates) => {
    const uniqueIds = [];

    const unique = duplicates.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.id);

      if (!isDuplicate) {
        uniqueIds.push(element.id);
        return true;
      }
      return false;
    });

    return unique;
  };

  //Au changement de résultat on recrée le tableau de marques
  useEffect(() => {
    const sortLuxeResults = () => {
      // Get non OneHR elements from results
      const luxeElements = results.filter(
        (element) => !element.type !== "formation_onehr"
      );
      const unfilteredBrands = [];

      // Get all brands from non OneHR content
      luxeElements.forEach((element) => {
        if (filters.brands.length > 0) {
          filters.brands.includes(element.extra.brand.id.toString()) &&
            unfilteredBrands.push({
              id: element.extra.brand.id,
              name: element.extra.brand.name,
            });
        } else {
          unfilteredBrands.push({
            id: element.extra.brand.id,
            name: element.extra.brand.name,
          });
        }
      });

      // Removing brand duplicates
      setLuxeBrands(removeDuplicates(unfilteredBrands));
    };

    const sortOneHRResults = () => {
      // Get OneHR elements from results
      const oneHRElements = results.filter(
        (element) => element.type === "formation_onehr"
      );
      const unfilteredCategories = [];

      // Get all OneHR categories
      oneHRElements.map((course) =>
        course.oneHr.forEach((category) => {
          if (filters.categories.length > 0) {
            filters.categories.includes(category.id.toString()) &&
              unfilteredCategories.push({
                id: category.id,
                name: category.title,
              });
          } else {
            unfilteredCategories.push({
              id: category.id,
              name: category.title,
            });
          }
        })
      );

      setOneHRCategories(removeDuplicates(unfilteredCategories));
    };

    sortLuxeResults();
    sortOneHRResults();
  }, [results, filters.brands, filters.categories, results]);

  const groupDataByLuxeBrands = () => {
    const luxeElements = results.filter(
      (element) => element.type !== "formation_onehr"
    );

    const brands = [];

    luxeBrands.forEach((brand) => {
      const groupedElements = luxeElements.filter(
        (element) => element.extra.brand.id === brand.id
      );

      brands.push({
        brand,
        elements: groupedElements,
      });
    });

    return brands;
  };

  const groupDataByOneHRCategory = () => {
    const oneHRElements = results.filter((element) =>
      element.hasOwnProperty("oneHr")
    );

    const categories = [];

    oneHRCategories.forEach((category) => {
      const groupedElements = oneHRElements.filter((element) =>
        element.oneHr.some((oneHR) => oneHR.id === category.id)
      );

      categories.push({
        brand: category,
        elements: groupedElements,
      });
    });

    return categories;
  };

  const groupData = () => {
    const data = [];
    const luxeData = groupDataByLuxeBrands();
    const oneHRData = groupDataByOneHRCategory();

    data.push(...luxeData);
    data.push(...oneHRData);

    return data;
  };

  const data = groupData();

  const NewsResult = ({ title, picture, type, id, extra }) => {
    return (
      <Link
        className="container__search-result__element"
        to={{ pathname: "/articles/" + extra.brand.id + "/" + id }}
      >
        <LazyLoad height="100px" once offset={300}>
          <div
            className="container__search-result-bg"
            style={{
              backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${picture})`,
            }}
          >
            <div className="search-result__element">
              <div
                className={`search-result__element--icon search-result__element--icon--${type}`}
              />
            </div>
            <div className="search-result__element__container--title">
              <p className="search-result__element--title">{title}</p>
            </div>
          </div>
        </LazyLoad>
      </Link>
    );
  };

  const VideoResult = ({ title, picture, type, extra, id }) => {
    return (
      <Link
        className="container__search-result__element"
        to={{
          pathname:
            "/brands/videos/" + extra.brand.id + "/watch=" + extra.youtube_id,
          state: {
            transitionName: "slide_in",
            fromHomepage: "true",
            id,
          },
        }}
      >
        <LazyLoad height="100px" once offset={300}>
          <div
            className="container__search-result-bg"
            style={{
              backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${picture})`,
            }}
          >
            <div className="search-result__element">
              <div
                className={`search-result__element--icon search-result__element--icon--${type}`}
              />
            </div>
            <div className="search-result__element__container--title">
              <p className="search-result__element--title">{title}</p>
            </div>
          </div>
        </LazyLoad>
      </Link>
    );
  };

  const ProductResult = ({ title, picture, type, id, extra }) => {
    let mediaUrl = `${window.location.origin.toString()}`;
    mediaUrl = mediaUrl.replace("://", "://media-") + "/";
    const [iframe, setiframe] = useState(false);
    const contentHeight = window.innerHeight;

    const openIframe = () => {
      setiframe(true);
      document.getElementsByClassName("search_container")[0].scrollTo(0, 0);
      document.getElementsByClassName("search_container")[0].style.overflow =
        "hidden";
    };

    return (
      <>
        {extra.link ? (
          <>
            <div
              className="container__search-result__element"
              onClick={openIframe}
            >
              <LazyLoad height="100px" once offset={300}>
                <div
                  className="container__search-result-bg"
                  style={{
                    backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${picture})`,
                  }}
                >
                  <div className="search-result__element">
                    <div
                      className={`search-result__element--icon search-result__element--icon--${type}`}
                    />
                  </div>
                  <div className="search-result__element__container--title">
                    <p className="search-result__element--title">{title}</p>
                  </div>
                </div>
              </LazyLoad>
            </div>
            {iframe && (
              <>
                <div className="close_iframe_container">
                  <button
                    className="close_iframe"
                    onClick={() => setiframe(false)}
                  ></button>
                </div>
                <iframe
                  src={extra.link}
                  id="catalog"
                  style={{ height: contentHeight - 120 }}
                  frameBorder="0"
                  scrolling="yes"
                  title="catalog"
                ></iframe>
              </>
            )}
          </>
        ) : (
          <Link
            className="container__search-result__element"
            to={{
              pathname: mediaUrl + extra.file,
              state: { transitionName: "slide_in" },
            }}
            target="_blank"
          >
            <LazyLoad height="100px" once offset={300}>
              <div
                className="container__search-result-bg"
                style={{
                  backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${picture})`,
                }}
              >
                <div className="search-result__element">
                  <div
                    className={`search-result__element--icon search-result__element--icon--${type}`}
                  />
                </div>
                <div className="search-result__element__container--title">
                  <p className="search-result__element--title">{title}</p>
                </div>
              </div>
            </LazyLoad>
          </Link>
        )}
      </>
    );
  };

  const FormationResult = ({ id, title, picture, type, extra }) => {
    let status;
    const formationSlug = slugme(title) + "-" + id;
    switch (extra.progression) {
      case "0":
        status = "not_started";
        break;
      case "50":
        status = "progress";
        break;
      case "100":
        status = "finished";
        break;

      default:
        status = "not_started";
        break;
    }

    const history = useHistory();

    return (
      <Link
        className="container__search-result__element"
        // to={{ pathname: "/formations/" + formationSlug }}
        to={{
          pathname: "/formations/" + formationSlug,
          // state: {
          //   prev: this.props.location.pathname,
          // },
        }}
        onClick={() =>
          saveGoBackPage(history.location.pathname + history.location.search)
        }
      >
        <LazyLoad height="100px" once offset={300}>
          <div
            className="container__search-result-bg"
            style={{
              backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${picture})`,
            }}
          >
            <div className="search-result__element">
              <span className="element__points">
                +{extra.points} <img src={images.points_stars} alt="" />
              </span>
              <div
                className={`search-result__element--icon search-result__element--icon--${type}`}
              />
            </div>
            <div className="search-result__element__container--title">
              <p className="search-result__element--title">{title}</p>
            </div>
            <div className={"element__progress__container " + status}>
              <div className="element__progress">
                <div
                  className="element__progress__bar"
                  style={{ width: extra.progression + "%" }}
                ></div>
              </div>
              <div className="formation_time">
                <div className="time">{extra.duration}</div>
              </div>
            </div>
          </div>
        </LazyLoad>
      </Link>
    );
  };

  const Results = (props) => {
    switch (props.type) {
      case "article":
        return <NewsResult {...props} />;

      case "video":
        return <VideoResult {...props} />;

      case "product_catalog":
        return <ProductResult {...props} />;

      case "formation_onehr":
        return (
          <div className="container__search-result__element_one-hr">
            <OneHrCourseItem
              id={props.id}
              title={props.title}
              duration={props.extra.duration}
              picture={props.picture}
              href={props.extra.href}
            />
          </div>
        );

      case "course":
      default:
        return <FormationResult {...props} />;
    }
  };

  const ListResult = () => {
    return (
      <>
        {results.map((el, i) => (
          <Results {...el} key={`result_${i}`} />
        ))}
      </>
    );
  };

  return (
    <>
      <h1 className="search-result__title">
        {results.length.toString()}{" "}
        {results.length > 1 ? t("results") : t("result")}{" "}
        {displayBrand && t("with_filter")}
      </h1>
      {displayBrand ||
      (filters["enableLuxeContent"] && filters["enableHRContent"]) === false ? (
        <div>
          {data.map((element, i) => {
            return (
              <div key={`jk-${i}`}>
                <div className="search-result__brands">
                  <h2 className="search-result__brands--name">
                    {element.brand.name}
                  </h2>
                  <p>
                    {element.elements.length}{" "}
                    {element.elements.length > 1 ? t("results") : t("result")}
                  </p>
                </div>
                <div className="container__search-result--brand">
                  {element.elements.map((e, i) => {
                    return <Results {...e} key={i} />;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="container__search-result">
          <ListResult />
        </div>
      )}
    </>
  );
};

//extract data from the redux store
const mapStateToProps = (state) => ({
  searchFilterList: state.searchFilters,
});

export default withRouter(
  withTranslation()(connect(mapStateToProps)(SearchResult))
);
